import React from 'react';
import './ProjectCard.css';

function ProjectCard({ index, title, description, onClick, icon, skills = [] }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <article
      className="project-item"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="project-item__top">
        <span className="project-index">{String(index).padStart(2, '0')}</span>
        <span className="project-cta">View project</span>
      </div>

      <div className="project-body">
        <div className="project-icon-container">
          <div
            className="project-icon-bg"
            style={{ backgroundImage: `url(${icon})` }}
          />
          <img src={icon} alt={`${title} icon`} className="project-icon" />
        </div>

        <div className="project-content">
          <h3 className="project-title">{title}</h3>
          <p className="card-project-description">{description}</p>
        </div>
      </div>

      {skills.length > 0 && (
        <div className="project-skills">
          {skills.slice(0, 4).map((skill) => (
            <span key={skill} className="project-skill-tag">
              {skill}
            </span>
          ))}
          {skills.length > 4 && (
            <span className="project-skill-tag">+{skills.length - 4}</span>
          )}
        </div>
      )}
    </article>
  );
}

export default ProjectCard;
